export default "__VITE_ASSET__DU5ulo7Q__"